<template>
  <Flex direction="column">
    <BaseCard
      v-for="category in groupedTableData"
      :key="category.categoryId"
      :heading="categoriesWithServices.find(c => c.id === category.categoryId)?.name"
      :notification="getChangedAmount(category.services)"
      collapsible
    >
      <Flex direction="column">
        <BaseCard
          gray
          v-for="service in category.services"
          :key="service.serviceId"
        >
          <Flex direction="column">
            <BaseText>{{ service.name }}</BaseText>
            <Flex>
              <BaseInput
                v-model="service.originalPrice"
                type="currency"
                :label="t('services.price_update.current_price')"
                v-test="'service-price-mobile-original-price'"
                disabled
              />
              <BaseInput
                v-model="service.newPrice"
                type="currency"
                :label="t('services.price_update.new_price')"
                :maxValue="999999999"
                v-test="'service-price-mobile-new-price'"
              />
            </Flex>
            <Flex
              v-if="service.newPrice !== service.originalPrice"
              justify="end"
            >
              <BaseText
                link
                @click="emit('onAction', { id: service.serviceId, option: 'undo' })"
                v-test="'service-price-mobile-reset'"
              >
                {{ t('global.actions.reset') }}
              </BaseText>
            </Flex>
          </Flex>
        </BaseCard>
      </Flex>
    </BaseCard>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { useI18n } from 'vue-i18n';
import { getChangedAmount } from './utils';

const { t } = useI18n();

defineProps<{
  groupedTableData: any;
  categoriesWithServices: any;
}>();

const emit = defineEmits(['onAction']);
</script>
